export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/portraits_caricatures.0efe649.svg";